import { render, staticRenderFns } from "./RecordInfo.vue?vue&type=template&id=58fe7895&scoped=true&"
import script from "./RecordInfo.vue?vue&type=script&lang=js&"
export * from "./RecordInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fe7895",
  null
  
)

export default component.exports